import envReader from '../config/envReader';

export const getMBPSPortalLink = (): string => 'https://b2b.mbps.eu/de/EUR/login';

export const addDomainToRelativeLink = (link: string): string => `${envReader.VITE_PUBLIC_URL}${link}`;
